import { Switch } from '@material-ui/core';
import styled from 'styled-components';

const Toggle = styled(Switch)`
  .MuiSwitch-thumb {
    color: #f1f1f1;
  }

  .MuiSwitch-track {
    background-color: ${({ theme }) => theme.secundaryBackgroundColor};
    opacity: 0.26;
  }

  .Mui-checked {
    .MuiSwitch-thumb {
      color: ${({ theme }) => theme.primaryBackgroundColor};
    }
  }

  .Mui-checked + .MuiSwitch-track {
    background-color: ${({ theme }) => theme.secundaryBackgroundColor} !important;
    opacity: 1;
  }

  .MuiSwitch-colorSecondary .Mui-checked {
    color: ${({ theme }) => theme.secundaryBackgroundColor};
  }
`;

export default Toggle;
